import ProductDropdown from '../ProductDropdown';
import styles from './ProductCardOptions.module.scss';
import {
  Button,
  Content,
  FontAwesomeProIcon,
  Heading,
  Modal,
} from '@wienenergiegithub/ui-next';
import React from 'react';
import { DialogDisclosure, useDialogStore } from '@ariakit/react';
import classNames from 'classnames';

const ProductCardOptions = ({
  aktionInline,
  calculated,
  handleDropdownChange,
  isAkvAktion,
  isDiscountActive,
  options,
  product,
  productOption,
  selectedAktion,
  setSelectedAktion,
}) => {
  const dialog = useDialogStore({ animated: true });

  const aktionsItems =
    aktionInline?.reduce(
      (
        itemsArray,
        {
          aktion_code: aktionCode,
          aktion_typ: aktionTyp,
          delta,
          delta_unit: deltaUnit,
        },
      ) => {
        if (aktionTyp === 'akv') {
          itemsArray.push({
            label: aktionCode,
            value: aktionCode,
            color: 'blue',
            delta,
            delta_unit: deltaUnit,
          });
        }
        return itemsArray;
      },
      [],
    ) || [];

  // @TODO: Disclosure and Modal should only appear if there are options to show
  const mixtypeLabel = (
    <span className={styles.label}>
      Zusammensetzung:
      <DialogDisclosure
        aria-label="Zusammensetzung"
        render={
          <Button className={styles.informationButton} shape="bubble">
            <FontAwesomeProIcon
              className={styles.infoIcon}
              color="primary"
              icon="info-circle"
              role="presentation"
            />
          </Button>
        }
        store={dialog}
      />
      <Modal header="Zusammensetzung" store={dialog} theme="default">
        <Content as="div" noSpacing>
          <Heading as="h5" className={styles.modalHeading} size="h6">
            {/* @TODO: This should be coming from the BE */}
            Wählen Sie aus unterschiedlichen Zusammensetzungs-Optionen:
          </Heading>
          {options?.mixtype.map(({ label, info_icon: infoIcon }) => (
            <Content as="div" key={`${product?.key}_${label}`}>
              <Heading className={styles.modalSection} size="h6">
                {label}
              </Heading>
              <Content withParser>{infoIcon}</Content>
            </Content>
          ))}
        </Content>
      </Modal>
    </span>
  );

  return (
    <div className={styles.container}>
      <div
        className={classNames('ProductCardList-equal-height', styles.dropdown)}
      >
        {options?.mixtype && (
          <ProductDropdown
            calculated={calculated}
            dataPurpose="Zusammensetzung"
            items={options?.mixtype}
            label={mixtypeLabel}
            name="Zusammensetzung"
            onSelect={value => {
              if (handleDropdownChange) {
                handleDropdownChange({ product, option: 'mixtype', value });
              }
            }}
            selectedItem={productOption?.mixtype}
          />
        )}
        {!!options?.bindung && (
          <ProductDropdown
            calculated={calculated}
            dataPurpose="Vertragsbindung"
            items={options?.bindung}
            label={`${options?.bindung[0]?.art_label}:`}
            name="Vertragsbindung"
            onSelect={value => {
              if (handleDropdownChange) {
                handleDropdownChange({ product, option: 'bindung', value });
              }
            }}
            selectedItem={productOption?.bindung}
          />
        )}
        {!!aktionInline && !!isDiscountActive && !!isAkvAktion && (
          <ProductDropdown
            calculated={calculated}
            dataPurpose="Gutscheincode"
            items={aktionsItems}
            label="Gutscheincode:"
            name="Gutscheincode"
            onSelect={value => {
              setSelectedAktion(value);
              handleDropdownChange({ product, option: 'aktionsCode', value });
            }}
            selectedItem={selectedAktion}
          />
        )}
      </div>
    </div>
  );
};

export default ProductCardOptions;
